module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI3NzZkNThmNDUzYzhmZTVkNmE4OWU5YzMxZWUyMjNmZi5zdmciOw=="


/*****************
 ** WEBPACK FOOTER
 ** ./app/fonts/fontawesome-webfont.svg?v=4.1.0
 ** module id = 32
 ** module chunks = 0
 **/